import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, MultiSelect, RowsContainer, ScrollableContainer, TextInput, TitleAndDescription, } from '@streamr/tv-ui';
import cx from 'classnames';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { PurchaseService } from '../../../services/purchase/PurchaseService';
import { BottomRight, Popup, TopCenter } from '../../../utils/popups';
import { AbstractPopup } from '../AbstractPopup';
import { PopupCssPreset } from '../Popup.styles';
const loadingPlaceholder = Array.from({ length: 5 }, (_, _index) => (_jsx(TitleAndDescription, { title: "", description: "", isLoading: true }, crypto.randomUUID())));
const MerchantSelectionPopup = ({ reject, resolve, variant, ...props }) => {
    let merchants;
    let isLoading;
    const productsOfPlatform = PurchaseService.getOutput().useProductsOfPlatform();
    if (productsOfPlatform === 'uninitialized' ||
        productsOfPlatform === 'loading') {
        if (productsOfPlatform === 'uninitialized') {
            PurchaseService.getNotificationInterface().notifyLoadProductsOfPlatform();
        }
        isLoading = true;
        merchants = [];
    }
    else {
        merchants = productsOfPlatform.map((p) => ({
            id: p.merchantId,
            name: p.name,
            description: '', // TODO
        }));
        isLoading = false;
    }
    const [search, setSearch] = useState('');
    const [selectedMerchants, setSelectedMerchants] = useState(new Set(PurchaseService.getOutput()
        .useProductsOfActiveBroadcast()
        .map((p) => p.merchantId)));
    const selectOptions = useMemo(() => {
        const filteredMerchants = search
            ? merchants.filter((merchant) => merchant.name
                .toLowerCase()
                .includes(search.toLowerCase()) ||
                merchant.description
                    .toLowerCase()
                    .includes(search.toLowerCase()))
            : merchants;
        return filteredMerchants.map((merchant) => {
            return {
                id: merchant.id,
                element: (_jsx(TitleAndDescription, { title: merchant.name, description: merchant.description })),
            };
        });
    }, [merchants, search]);
    const handleSubmit = () => {
        console.log('selectedMerchants', selectedMerchants);
        // The submit button is disabled until the productsOfPlatform have been loaded. Threfore this
        // variable contains an array, not 'uninitialized' or 'loading'
        const products = productsOfPlatform.filter((p) => selectedMerchants.has(p.merchantId));
        PurchaseService.getNotificationInterface().notifyProductsOfActiveBroadcastChanged(products, true);
        resolve();
    };
    return (_jsx(MerchantSelectionPopupRoot, { reject: reject, translateFn: variant === 'top-right' ? BottomRight : TopCenter, ...props, className: cx(props.className, variant), children: _jsxs(RowsContainer, { children: [_jsx("div", { children: _jsx(TextInput, { placeholder: "Search", value: search, onChange: (e) => setSearch(e.target.value) }) }), _jsx(PaymentInfoText, { children: "The products of the selected merchants will be available in this broadcast." }), isLoading && loadingPlaceholder, !isLoading && (_jsx(MultiSelectContainer, { children: _jsx(ScrollableContainer, { children: _jsxs(ScrollableContainerInner, { children: [_jsx(MultiSelect, { options: selectOptions, selectedIds: Array.from(selectedMerchants), onChange: (value) => setSelectedMerchants(value) }), !selectOptions.length && (_jsx(NoResultsText, { children: "No results found" }))] }) }) })), _jsx(DoneButton, { disabled: isLoading, onClick: handleSubmit, children: "Done" })] }) }));
};
const MerchantSelectionPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1.5rem;
    --Popup_Width: 90vw;

    @media (min-width: 30rem) {
        --Popup_Width: 25rem;

        &.top-right {
            ${PopupCssPreset.AnchoredBottomRight};
        }

        &.bottom-right {
            ${PopupCssPreset.AnchoredTopRight};
        }
    }
`;
const DoneButton = styled(Button) `
    --Button_Background: var(--tv-ui-color-3);
    --Button_TextColor: var(--tv-ui-color-4);
    --Button_TextSize: 1.125rem;
    --Button_HoverBackground: var(--tv-ui-color-3);
    --Button_BorderRadius: 1rem;
    --Button_Padding: 1rem;
`;
const MultiSelectContainer = styled.div `
    margin-left: -1rem;
    margin-right: -1rem;
`;
const ScrollableContainerInner = styled.div `
    min-height: 50vh;
    max-height: 50vh;
`;
const PaymentInfoText = styled.p `
    font-size: 0.875rem;
    color: var(--tv-ui-color-8);
    margin-bottom: 0;
`;
const NoResultsText = styled.div `
    text-align: center;
`;
const merchantSelectionPopup = Popup.create(MerchantSelectionPopup);
export function showMerchantSelectionPopup(options) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await merchantSelectionPopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
